import axios from './apiClient';

export interface ChangelogEntry {
  version: string;
  date?: string;
  changes: string[];
}

export async function fetchVersion(): Promise<string> {
  const { data } = await axios.get<{ version: string }>('/version');
  return data.version;
}

export async function fetchChangelogs(): Promise<ChangelogEntry[]> {
  const { data } = await axios.get<ChangelogEntry[]>('/version/changelogs');
  return data;
}

export async function fetchChangelogsSince(version: string): Promise<ChangelogEntry[]> {
  const { data } = await axios.get<ChangelogEntry[]>(`/version/changelogs?since=${version}`);
  return data;
}
